import { render, staticRenderFns } from "./FeriadoConfiguração.vue?vue&type=template&id=1690da91&scoped=true"
import script from "./FeriadoConfiguração.vue?vue&type=script&lang=ts"
export * from "./FeriadoConfiguração.vue?vue&type=script&lang=ts"
import style0 from "./FeriadoConfiguração.vue?vue&type=style&index=0&id=1690da91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1690da91",
  null
  
)

export default component.exports